<template>
  <el-dialog
    v-if="visible"
    :modal-append-to-body="false"
    :modal="false"
    :visible.sync="visible"
    show-close
    width="1000px"
    :title="$l('INDEX.dialog_title_goods_size_detail') || '产品尺寸详情'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Table
      ref="identify"
      :isSingle="isSingle"
      :spuGoodsName="spuGoodsName"
      :tableData="tableData"
    />

    <span slot="footer">
      <el-button size="small" @click="close()">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="confirm()">{{
        $l('INDEX.btn_confirm') || '确认'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Table from './table.vue'
export default {
  components: { Table },
  props: {
    visible: { type: Boolean, default: false },
    isSingle: { type: Boolean, default: false },
    spuGoodsName: { type: String, default: '' },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async confirm() {
      const validResult = await this.$refs.identify.validEvent()
      if (!validResult) return
      const data = this.$refs.identify.getTableData()
      this.$emit('update', data)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
